"use client";

import React from "react";
export const LoadableContext = React.createContext(null);
if (process.env.NODE_ENV !== "production") {
    LoadableContext.displayName = "LoadableContext";
}

//# sourceMappingURL=loadable-context.shared-runtime.js.map